// React
import React, { useEffect, useState } from 'react';
// componentes
import Title from 'components/TitleWithIcon';
import FiltrosEstadisticasSolicitudes from 'pages/CierrePadron/FormularioGenerarInforme'
import ComponenteMostrarInformeGenerado from 'pages/CierrePadron/MostrarInformeGenerado'
import ApiServices from 'services/ApiServices';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import DialogLoadingMessage from 'components/LoadingMessage/index'

export default function ComponenteInformeDeCierrePadronOperadores (props) {
    const [loadingMessage, setLoadingMessage] = useState({open: false, title: ''});
    const [data, setData] = useState({status: false, base64: '', showComponent: false}); 
    const [userData, setUserData] = useState(); 

    //consultamos si el operador ya tiene generado su informe o no
    const VerificacionSiExisteInformeGeneradoDelOperador = async (datos) =>{
        setData({status: false, base64: '', showComponent: false})
        setLoadingMessage({open: true, title: 'Verificando si existe informe ...'})
        let data = {
            coddep: datos?.codDep,
            codmun: datos?.codMun,
        }
        try{
            const response = await ApiServices.generarInformeCierre.obtenerBase64(data);    
            if (response.error){
                setData({status: false, base64: '', showComponent: true})
                // showMessagePersonalizedPosition('warning','Advertencia', response.error)
            }else{
                if(response.data === '' || response.data === null || response.data === undefined)
                    setData({status: false, base64: '', showComponent: true})
                else
                    setData({status: true, base64: response.data, showComponent: true})
            }
        }catch(exception){
            showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de Nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
        }
        setLoadingMessage({open: false, title: ''})
    }
    // funcion para obtener los datos del operador
    const FuncionObtenerDeptoAndMunUsuario = async () =>{
        setLoadingMessage({loading: true, title:'Obteniendo datos ...'})
        try{
            const response = await ApiServices.generarInformeCierre.getDeptoMpioUsuarioInforme();
            if(response.error){
                showMessagePersonalizedPosition('warning','¡Advertencia!', response.error?.message,'center')
            }else {  
                showMessagePersonalizedPosition('success','¡BIEN!', 'Datos obtenidos correctamente.','center')
                setUserData(response.data)
                VerificacionSiExisteInformeGeneradoDelOperador(response.data)
            } 
        }catch(exception){
            showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
        }     
        setLoadingMessage({loading: false, title:''})        
    }    
    useEffect(()=>{
        FuncionObtenerDeptoAndMunUsuario();
    },[]);    
    return (
        <div style={{backgroundColor:'#D4D8E1'}}>
            {
                loadingMessage.open && (
                    <DialogLoadingMessage open={loadingMessage.open} title={loadingMessage.title}/>
                )
            }             
            <Title title={'Informe de Cierre Operadores'} icon={"/assets/Reporte.png"}/>
            {
                (data.showComponent) && (
                    (!data.status) ?<FiltrosEstadisticasSolicitudes setData={setData} userData={userData}/>
                    :<ComponenteMostrarInformeGenerado base64={data.base64} />
                )
            }
        </div>
    )
}